import { isEmpty } from 'ramda';

export const getTagsString = (tags: string[] = []) => {
  if (tags && !isEmpty(tags)) {
    return `Tags: ${tags.join(', ')}`;
  }
};
